var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: _vm.wrapperClass },
    _vm._l(_vm.fields, function (field) {
      return _c(
        "div",
        { key: `${_vm.rowKeyPrefix}-${field.key}`, class: _vm.rowClass },
        [
          _c("span", { class: _vm.labelClass }, [
            _vm._v(_vm._s(_vm.$t(field.labelKey))),
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              class: _vm.valueClass(field),
              attrs: { draggable: _vm.isFieldDraggable(field) },
              on: {
                dragstart: function ($event) {
                  return _vm.onFieldDragStart($event, field)
                },
                dragend: _vm.onFieldDragEnd,
              },
            },
            [
              field.key === "prompt" ||
              field.key === "concept" ||
              field.key === "category_shape"
                ? _c("GenerationHistoryPromptPopover", {
                    attrs: {
                      text: field.value,
                      tooltip: _vm.promptTooltip,
                      interactive: _vm.promptTooltip,
                    },
                  })
                : [_vm._v(_vm._s(field.value))],
            ],
            2
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }